import { PROVIDERS_HIRER_REQUEST_SUCCESS } from "../action.types";
import InitialState from "../initial.state";

export default (state = InitialState.providerHirers, action) => {
  switch (action.type) {
    case PROVIDERS_HIRER_REQUEST_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/provider/providerHires.reducer.js